import { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import { useNavigate } from '@tanstack/react-router';
import useStore, { selectCountryTheme, selectFavoriteCountryId } from '@/hooks/client/useStore';
import Logo from '@/common/Logo';
import Drawer from './Drawer';
import PropTypes from 'prop-types';

const css = {
  appBar: (transparent, color) => ({
    position: transparent ? 'fixed' : 'static',
    backgroundColor: transparent ? 'transparent' : color,
    minHeight: '52px',
    zIndex: 1,
    boxShadow: transparent && 'none',
  }),
};

const AppHeader = ({ transparent = false }) => {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const countryTheme = useStore(selectCountryTheme);
  const countryCode = useStore(selectFavoriteCountryId);
  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const handleLogoClick = () => navigate({ to: '/' });
  return (
    <>
      {/* Top App Bar */}
      <AppBar sx={css.appBar(transparent, countryTheme.navColor)}>
        <Toolbar>
          {/* Logo on the left */}
          <Box onClick={handleLogoClick}>
            <Logo sx={{ width: countryTheme.logoMinWidth, height: countryTheme.logoMinHeigth }} />
          </Box>
          <Box sx={{ flexGrow: 1 }} />
          {/* Menu icon on the right */}
          <IconButton
            size="large"
            edge="end"
            aria-label="menu"
            sx={{ color: countryTheme.accentColor2 }}
            onClick={toggleDrawer(true)}
          >
            <MenuRoundedIcon sx={{ fontSize: 48 }} />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Right-side Drawer */}
      <Drawer drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
    </>
  );
};

AppHeader.propTypes = {
  transparent: PropTypes.bool,
};

export default AppHeader;
